import React, { useState, useEffect } from 'react';
import SearchBar from './SearchBar';
import ResourceCard from './ResourceCard';
import { PATH_ROADMAPS } from './data/mockRoadmaps.js';
import './Resources.css';

const ResourcesPage = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [allResources, setAllResources] = useState([]);
  const [filteredResources, setFilteredResources] = useState([]);

  // Flatten all resources, articles, and videos from all categories
  useEffect(() => {
    const resources = [];

    Object.values(PATH_ROADMAPS).forEach(category => {
      if (category.resources) {
        category.resources.forEach(r => resources.push({ ...r, category: category.title }));
      }
      if (category.articles) {
        category.articles.forEach(a => resources.push({ ...a, category: category.title }));
      }
      if (category.videos) {
        category.videos.forEach(v => resources.push({ ...v, category: category.title }));
      }
    });

    setAllResources(resources);
    setFilteredResources(resources);
  }, []);

  // Live search: filter as the user types
  useEffect(() => {
    const term = searchTerm.trim().toLowerCase();

    if (!term) {
      setFilteredResources(allResources);
      return;
    }

    const results = allResources.filter(resource =>
      resource.title.toLowerCase().includes(term) ||
      resource.description.toLowerCase().includes(term) ||
      (resource.type && resource.type.toLowerCase().includes(term)) ||
      (resource.category && resource.category.toLowerCase().includes(term))
    );

    setFilteredResources(results);
  }, [searchTerm, allResources]);

  const handleSearchChange = (value) => {
    setSearchTerm(value);
  };

  const handleSearchSubmit = () => {
    // Search happens live via useEffect, optional extra behavior here
    console.log(`Search submitted for: "${searchTerm}"`);
  };

  return (
    <div className="resources-page section-padding">
      <div className="resources-header">
        <h1 className="section-heading">Curated Learning Library</h1>
        <p className="resources-subtext">
          Access thousands of resources across all categories.
        </p>
      </div>

      <div className="search-bar-section">
        <SearchBar
          searchTerm={searchTerm}
          onSearchChange={handleSearchChange}
          onSearchSubmit={handleSearchSubmit}
        />
      </div>

      <div className="resource-results-count">
        Showing <strong>{filteredResources.length}</strong> relevant results.
      </div>

      <div className="resources-grid">
        {filteredResources.length > 0 ? (
          filteredResources.map((resource, index) => (
            <ResourceCard key={index} {...resource} />
          ))
        ) : (
          <div className="no-results">
            No resources found matching "{searchTerm}". Try a different term.
          </div>
        )}
      </div>
    </div>
  );
};

export default ResourcesPage;
